import { useHistory, useLocation } from "react-router-dom";
import React from "react";

export const SiniestrosCloseIcon = () => {
    let query = useQuery();
    let history = useHistory();
    let icon = query.get("icon");
    const style = {
        position: "absolute",
        right: 0,
        top: 0,
    };
    if (icon) {
        return (
            <div className={"siniestros-info"}>
                <button
                    type="button"
                    className="close"
                    title="Cerrar"
                    aria-label="Close"
                    onClick={() => {
                        history.goBack();
                    }}
                    style={style}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        );
    }
    return null;
};

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}
